var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartTransactIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Post add",
    clipPath: "url(#clip0_2741_130)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.3333 32.0334H8.33333V11.6667H20V8.33337H8.33333C6.5 8.33337 5 9.83337 5 11.6667V31.6667C5 33.5 6.5 35 8.33333 35H28.3333C30.1667 35 31.6667 33.5 31.6667 31.6667V20H28.3333V32.0334Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31.6667 3.33334H28.3333V8.33334H23.3333C23.35 8.35001 23.3333 11.6667 23.3333 11.6667H28.3333V16.65C28.35 16.6667 31.6667 16.65 31.6667 16.65V11.6667H36.6667V8.33334H31.6667V3.33334Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25 15H11.6667V18.3333H25V15Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M11.6667 20V23.3333H25V20H20H11.6667Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M25 25H11.6667V28.3333H25V25Z",
    fill: "#FFFFFF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2741_130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartTransactIcon);
export default __webpack_public_path__ + "static/media/startTransact_icon.669ed10f297fc71076e4569933b46d60.svg";
export { ForwardRef as ReactComponent };